import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import { exportExcel } from "./exportExcel/api";
import { exportPDF } from "./exportPDF/api";
import { settle } from "./settle/api";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { IInstallmentsGetAllParams, IInstallmentsResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IInstallmentsResponse>>,
  IPathBaseParam,
  IPaginationParams & IInstallmentsGetAllParams
>("installments");
const getApis = createGetApi<
  IApiResponse<IInstallmentsResponse>,
  IPathByIdParam,
  object
>("installments");

export const installments = {
  ...getAllApis,
  ...getApis,
  settle,
  exportPDF,
  exportExcel,
};
